module.exports = __webpack_public_path__ + "img/干泵9.fb5054f2.png";